import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
//import logo from './logo.svg'
//import api from './api'
import './App.css'
import HomePage from './pages/HomePage'
import Om from './pages/Om'
import Dialogduk from './pages/Dialogduk'
import Linker from './pages/Linker'
import Login from './pages/Login'
import Overview from './pages/Overview'
import Kontakt from './pages/Kontakt'
import Spill from './pages/Spill'

class App extends Component {
  componentDidMount() {
    //api('/test', { hello: 'world' })
    // .then(response => console.log(response))
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <link
            rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.0.13/css/all.css"
            integrity="sha384-DNOHZ68U8hZfKXOrtjWvjxusGo9WQnrNx2sqG0tfsghAvtVlRW3tvkXWZh58N9jp"
            crossOrigin="anonymous"
          />
        </header>
        <Router>
          <div>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/om" component={Om} />
            <Route exact path="/dialogduk" component={Dialogduk} />
            <Route exact path="/spill" component={Spill} />
            <Route exact path="/linker" component={Linker} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/oversikt" component={Overview} />
            <Route exact path="/kontakt" component={Kontakt} />
          </div>
        </Router>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js